export * from './get-comparison-result-label';
